<template>
    <div></div>
</template>
<script>
export default {
    name: 'Index',

    data() {
        return {}
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['工作台'])
        this.init()
    },
    methods: {
        init() {}
    }
}
</script>
